import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"

const PROPERTY = "reference"

export const schema = (formatMessage) => Validation.string(formatMessage({id: "insights.validation.required"}))

const Reference = ({cycle, onChange, required, label, validation, formatMessage, ...props}) => {
  const intlValidation = validation || schema(formatMessage)

  return (
    <Input
      name={PROPERTY}
      type="text"
      value={get(cycle, PROPERTY)}
      onChange={(value) => onChange(cycle, PROPERTY, value)}
      label={`${label}${required ? "*" : ""}`}
      {...props}
      id={id(PROPERTY, props)}
      validation={intlValidation} />
  )
}

Reference.propTypes = {
  cycle: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  validation: PropTypes.object,
  formatMessage: PropTypes.func.isRequired
}

Reference.defaultProps = {
  required: false,
  placeholder: "",
  label: "",
  hint: "",
  validation: null,
  id: PROPERTY
}

export default injectIntl(Reference)
